import { render, staticRenderFns } from "./NotificacaoAdmin.vue?vue&type=template&id=6ef04149&scoped=true"
import script from "./NotificacaoAdmin.vue?vue&type=script&lang=js"
export * from "./NotificacaoAdmin.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoAdmin.vue?vue&type=style&index=0&id=6ef04149&prod&lang=css"
import style1 from "./NotificacaoAdmin.vue?vue&type=style&index=1&id=6ef04149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef04149",
  null
  
)

export default component.exports